import { DetailedSolutionApiResponse } from "../types";

export const placeholder = "-";

export const urlRegex =
  /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/i;

export const websiteUrlRegex = /^(projects|archived-projects)\/[a-zA-Z-]+$/;

export const emptyOutcomes: NonNullable<
  DetailedSolutionApiResponse["outcomes"]
> = {
  v2: [],
  v3: [],
};

export const shortDescriptionMaxWords = 100;

export const richTextMaxWords = {
  "project-information": 250,
  "area-through-time": 200,
  "good-for-people": 300,
  "good-for-earth": 300,
} as const;

export const wordLimitMessage = (maxWords: number) =>
  `Text should be ${maxWords} words or less`;

export const tipTapLinkProtocols = ["https"];
export const allowedRichTextTags = [
  "a",
  "br",
  "em",
  "li",
  "ol",
  "p",
  "strong",
  "ul",
];
export const allowedRichTextAttributes = ["href", "title", "target", "rel"];
